export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/blue-pdf.9f105a26.svg","height":16,"width":12,"blurWidth":0,"blurHeight":0};